import { useQuery } from '@tanstack/react-query';
import { ScheduleMemo, ScheduleMemoType } from '#types/schedule';
import { fetcher } from '../libs';
import queryKeys from '../queryKeys';

interface Params {
  memoType?: ScheduleMemoType;
  /** 날짜 - 일간 메모인 경우 사용 (YYYY-MM-DD) */
  date?: string;
  /** 주간 및 월간 메모의 경우 사용 */
  year?: number;
  /** 월간 메모의 경우 사용 (1~12) */
  month?: number;
  /** 주간 메모의 경우 사용 (1~53) */
  week?: number;
}

/**
 * 코치 - 본인 메모 불러오기
 * @link https://api-dev.fibud.kr/api#/%EA%B3%84%EC%A0%95/AccountsController_findCoachMemo
 * @param param0
 * @returns
 */
export default function useCoachMemoQuery({
  memoType,
  date,
  year,
  month,
  week
}: Params) {
  return useQuery(
    [queryKeys.SCHEDULE, 'memo', memoType, date, year, month, week],
    () =>
      fetcher<ScheduleMemo>('/accounts/coach-memo', {
        params: {
          memoType,
          date,
          year,
          month,
          week
        }
      }),
    {
      enabled: !!memoType
    }
  );
}
